import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import {
  getOnboardingTaskLists,
  OutReachProps,
  sendOutreachSmsTask,
} from "./taskApi";
import { AppContext } from "../context/app";
import { CelebrationType } from "./metricsApi";

export function useOnboardingTaskListsQuery() {
  const app = useContext(AppContext);
  return useQuery({
    queryKey: ["onboarding-task-lists", app.client!.uuid],
    queryFn: () => getOnboardingTaskLists(),
  });
}

export function useSendOutreachSmsTask(
  recipientUuid: string,
  eventType: CelebrationType,
) {
  return useMutation({
    mutationKey: ["send-outreach-sms", `${recipientUuid}-${eventType}`],
    mutationFn: (outReachProps: OutReachProps) =>
      sendOutreachSmsTask(outReachProps),
  });
}
